module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.250c4e2e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Regular.eot
// module id = 86
// module chunks = 3